export const appAuth0 = {
  domain: 'irmarketplace.us.auth0.com',
  clientId: 'yzZzZmjQ4BYwefvsWQbbLpcRTFPBrZrN',
  audience: 'https://irmarketplace.us.auth0.com/api/v2/'
};